import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { applyTheme } from './utils/theme';
import { registerServiceWorker } from './utils/pwaUpdate';
import App from './App';

applyTheme();

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		registerServiceWorker();
	});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// PWA Service Worker registration handled in utils/pwaUpdate.js